module.exports = __webpack_public_path__ + "static/services-image-1_m-fdc40f49b4a51236a70353d17a1ebbbd.jpg";